module.exports = __webpack_public_path__ + "static/media/cover-business-profile_empty.7fc2a6e3.svg";